<div *ngIf="isLoading">
	Loading Terminations
	<mat-icon>
		<mat-spinner diameter="18"> </mat-spinner>
	</mat-icon>
</div>
<div class="margin-bottom-sm" *ngIf="studentTerminationStatuses.length > 0 && !isLoading">
	<mat-accordion>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="italic"
					[ngClass]="{'danger': studentTerminationStatuses.length > 0 && studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1
					, 'primary': studentTerminationStatuses.length > 0 && studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
					{{studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1 ? 'Terminated: '
					: '' : ''}}
					{{studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE + ': ' :
					''}}
					{{(studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STATUS_DATE :
					'') | cleanDate | simpleDate}}
				</mat-panel-title>
				<mat-panel-description>
					{{studentTerminationStatuses.length > 0 ? 'Created By: ' + studentTerminationStatuses[0].CREATED_BY
					: 'Open to Terminate Child'}}{{studentTerminationStatuses.length > 0 &&
					studentTerminationStatuses[0].CREATED_DATE ? ': ' : ''}}
					{{(studentTerminationStatuses.length > 0 ? studentTerminationStatuses[0].CREATED_DATE : '')
					| cleanDate | simpleDate}}
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="margin-bottom-lg">
				<mat-card-title>
					Termination History
				</mat-card-title>
				<mat-divider> </mat-divider>

				<div class="margin-top-md">
					<mat-table [dataSource]="tableDataSource" class="table-responsive mat-elevation-z1" matSort>
						<ng-container matColumnDef="STATUS_DATE">
							<mat-header-cell *matHeaderCellDef> Termination Date </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{(element.STATUS_DATE) | cleanDate | simpleDate}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="STUDENT_TERMINATION_STATUS_TYPES.TYPE">
							<mat-header-cell *matHeaderCellDef> Reason </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.STUDENT_TERMINATION_STATUS_TYPES.TYPE}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="CREATED_BY">
							<mat-header-cell *matHeaderCellDef> Created By </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.CREATED_BY}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="CREATED_DATE">
							<mat-header-cell *matHeaderCellDef> Created On </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.CREATED_DATE | cleanDate | simpleDate}}
								</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>